import { notifications } from '@mantine/notifications';

export const creationNotification = (
  createdItemTitle: string,
  success: boolean
) => {
  if (success) {
    notifications.show({
      title: 'Başarılı.',
      message: `${createdItemTitle} başarılı bir şekilde oluşturuldu.`,
      autoClose: 4000,
      withBorder: true,
      color: 'green'
    });
  } else {
    notifications.show({
      title: 'Bilinmeyen Hata.',
      message: 'Oluşturma başarısız.',
      color: 'red',
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const deleteNotification = (success: boolean) => {
  if (success) {
    notifications.show({
      title: 'Başarılı.',
      message: `Silme işlemi başarılı.`,
      autoClose: 4000,
      withBorder: true,
      color: 'green'
    });
  } else {
    notifications.show({
      title: 'Bilinmeyen Hata.',
      message: 'Silme işlemi başarısız.',
      color: 'red',
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const updateNotification = (success: boolean) => {
  if (success) {
    notifications.show({
      title: 'Başarılı.',
      message: `Bilgiler başarılı bir şekilde güncellendi.`,
      autoClose: 4000,
      withBorder: true,
      color: 'green'
    });
  } else {
    notifications.show({
      title: 'Bilinmeyen Hata.',
      message: 'Bilgi güncellenmesi sırasında bir hata meydana geldi.',
      color: 'red',
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const saveNotification = (success: boolean) => {
  if (success) {
    notifications.show({
      title: 'Kaydedildi.',
      message: `Kaydetme işlemi başarılı.`,
      autoClose: 4000,
      withBorder: true,
      color: 'green'
    });
  } else {
    notifications.show({
      title: 'Bilinmeyen Hata.',
      message: 'Kaydetme sırasında bir hata meydana geldi.',
      color: 'red',
      autoClose: 4000,
      withBorder: true,
    });
  }
};

export const errorNotification = () => {
  notifications.show({
    title: 'Bilinmeyen Hata.',
    message: 'İşlem sırasında beklenmedik bir hata oluştu.',
    color: 'red',
    autoClose: 4000,
    withBorder: true,
  });
};

export const loginErrorNotification = () => {
  notifications.show({
    title: 'Giriş Yapılamadı.',
    message: 'Giriş bilgilerini doğru girdiğinizden emin olun.',
    color: 'red',
    autoClose: 4000,
    withBorder: true,
  });
};
